export default "__VITE_ASSET__pwDTDf_G__"